import {useEffect,useState,useLayoutEffect} from 'react'
import {Box,Typography,Button,Grid,IconButton,CircularProgress, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, Divider} from '@mui/material'
import Header from '../Components/Header'
import {useTheme,styled } from '@mui/material/styles'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {useNavigate} from 'react-router-dom'
import Snackbar from '@mui/material/Snackbar'
import Link from '@mui/material/Link';
import { Alarm, ArrowBack, Edit, EmailOutlined, LinkRounded} from '@mui/icons-material';
import MultiInput from '../Components/MultiInput';
import UserInput from '../Components/UserInput';
import start_application from '../Redux/reducers/start_application';
import { FileUploader } from 'react-drag-drop-files';
import send_application from '../Redux/reducers/send_application';
import axios from 'axios';
import CardViewDialog from '../Components/CardViewDialog';
import { login } from '../Redux/authSlice';
import AnalyzeDialog from '../Components/AnalyzeDialog';


const ContainerBox = styled(Box, {
	})(({ theme}) => ({
		transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowY: 'auto',
	overflowX: 'hidden',
	'&::-webkit-scrollbar': {
		width: 7,
		backgroundColor: '#000000'
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#ffffff',
		borderRadius: 5
	},
	minHeight:250,
	justifyContent:"flex-start",
	alignItems:"center",
	borderRadius:10,
	maxHeight:500
	})
);

const JobApplication = ()=>{

	const [open,setOpen] = useState(false)
	const [message,setMessage] = useState('')
	const navigate = useNavigate()
	const theme = useTheme()
	const dispatch = useDispatch()
	const user = useSelector(state => state?.auth.user);
	const [email,setEmail] = useState(user?.email)
	const [response,setResponse] = useState("")
	const [responses,setResponses] = useState([])
	const [hasStarted,setHasStarted] = useState(false)
	const [submitting,setSubmitting] = useState(false)
	const data = useSelector(state => state?.job.job);
	const [recentQuestion,setRecentQuestion] = useState(data?.questions[0])
	const [uploading, setUploading] = useState(false)
	const [deleting, setDeleting] = useState(false)
	const [hasEnded, setHasEnded] = useState(false)
	const [index, setIndex] = useState(0)
	const [file, setFile] = useState(null)
	const [showModal,setShowModal] = useState(false)
	const [isMatched,setIsMatched] = useState(false)
	const [matching,setMatching] = useState(false)
	const [isLogoUploaded, setIsLogoUploaded] = useState(false);
	const [isDocUploaded, setIsDocUploaded] = useState(false);
	const [logoUrl, setLogoUrl] = useState(null);
	const [docUrl, setDocUrl] = useState(null);
	const [fileCv, setFileCv] = useState(null);
	const [edited,setEdited] = useState("")
	const [isUploaded, setIsUploaded] = useState(false);
	const [analyzeData, setAnalyzeData] = useState({});
	const [select, setSelect] = useState(0);
	const [viewDoc, setViewDoc] = useState(false);	
	const [showEdited,setShowEdited] = useState(false)
	const fileTypes = ["JPG","JPEG", "PNG"] 
	const docTypes = ["PDF"] 

async function handleSend (){
	try{
		if (hasStarted) {
			if (recentQuestion?.type !== "Files" && recentQuestion?.type !== "Image") {
				
				const send_data = {
					id:data?.id,
					email:email,
					index:index,
					type:recentQuestion?.type,
					isCv : recentQuestion?.isCv ? recentQuestion?.isCv : false,
					question:recentQuestion?.content,
					response:recentQuestion?.type === "Multiple" ? responses : response
				}

				const token = user?.accessToken
			
				await send_application(dispatch,send_data,token,setOpen,setMessage,setResponse,setResponses,setHasStarted,setHasEnded,setRecentQuestion,setIndex,setSubmitting)
			
			} else {
				if (isLogoUploaded || isDocUploaded) {
					
					const send_data = {
						id:data?.id,
						email:email,
						index:index,
						type:recentQuestion?.type,
						question:recentQuestion?.content,
						response:isLogoUploaded ? logoUrl : docUrl
					}

					const token = user?.accessToken
				
					await send_application(dispatch,send_data,token,setOpen,setMessage,setResponse,setResponses,setHasStarted,setHasEnded,setRecentQuestion,setIndex,setSubmitting)
				} else {
					setMessage("please, upload the file before to continue")
					setOpen(true)
				}
			}
		} else{
			if (email !== "") {

				const send_data = {
					id:data?.id,
					user:{
						email:user?.email,
						first_name:user?.first_name,
						last_name:user?.last_name,
						position:user?.position,
						cv:user?.cv,
						nationality:user?.nationality,
						birthday:user?.birthday
					}
				}

				const token = user?.accessToken

				await start_application(dispatch,send_data,token,setOpen,setMessage,setRecentQuestion,setHasStarted,setHasEnded,setIndex,setSubmitting)
			
			} else {
				setMessage("Please, write down your email to start the application")
				setOpen(true)
			}
		}
	}catch(err){
		console.log(err)
	}
}

async function handleMatch(){
	try {

		setMatching(true)

		const send_data = {
			description:data?.description,
			first_name:user?.first_name,
			id:data?.id,
			email:user?.email,
			toSelect:false
		}

		// console.log(send_data)

		const match = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}cv/match-resume`,send_data,{
			headers:{
				"Content-Type":"application/json",
				"Authorization":`Bear ${user?.accessToken}`
			}
		}).catch(err=>{
			setMessage("Error while matching, please try later")
			setOpen(true)
			setMatching(false)
			console.log(err)
		})

		if (match?.status == 200 && match?.data.success) {
			if (match?.data?.data?.isMatch ) {
				setMessage("Your Resume match this job")
				setOpen(true)
				setMatching(false)
				setIsMatched(true)
			} else {
				setMessage("Your Resume do not match this job")
				setOpen(true)
				setShowModal(true)
				setAnalyzeData(match?.data?.data)
				setMatching(false)
			}
		} else {
			setMessage(match?.data.message)
			setOpen(true)
			setMatching(false)
		}
	} catch (error) {
		console.log(error)
	}
}

async function handleUpdateCv(){
try {

	setUploading(true)

	let formData = new FormData()

	formData.append("file",fileCv)
	formData.append("email",user?.email)

	const upload = await axios.put(`${process.env.REACT_APP_SOCKET_URL}api/cv/file/update/`,formData,{
		headers:{
			"Content-Type":"multipart/form-data",
			"Authorization":`Bear ${user?.accessToken}`
		}
	}).catch(err=>{
		setMessage("Error while uploading")
		setOpen(true)
		setUploading(false)
		console.log(err)
	})

	if (upload?.status == 200 && upload?.data?.success) {
		
		const userData = {
			...user,
			cv:upload?.data?.url
		}

		dispatch(login(userData))
		localStorage.removeItem("iTestUser")
        localStorage.setItem("iTestUser",JSON.stringify(userData))
		setIsUploaded(true)
		setFileCv(null)
		setMessage("file updated with success")
		setOpen(true)
		setUploading(false)
	} else {
		setMessage(upload?.data?.message)
		setOpen(true)
		setUploading(false)
	}
	
} catch (error) {
	console.log(error)
	setUploading(false)
}
}

async function handleUploadFile(data,isLog){
try {

	setUploading(true)

	let formData = new FormData()

	formData.append("file",data)
	formData.append("isLog",isLog)

	console.log(isLog)

	const upload = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/data/usr/file/upload/`,formData).catch(err=>{
		setMessage("Error while uploading")
		setOpen(true)
		setUploading(false)
		console.log(err)
	})

	if (upload?.status == 200 && upload?.data?.success) {
		if (isLog) {
			setLogoUrl(upload?.data?.url)
			setIsLogoUploaded(true)
			// setFile(null)
		} else {
			setDocUrl(upload?.data?.url)
			setIsDocUploaded(true)
			// setFiles(null)
		}
		setMessage("file uploaded on the server")
		setOpen(true)
		setUploading(false)
		// setUploaded(true)
	} else {
		setMessage(upload?.data?.message)
		setOpen(true)
		setUploading(false)
	}
	
} catch (error) {
	console.log(error)
	setUploading(false)
}
}

async function handleDeleteFile(url,isLog){
try {

	setDeleting(true)

	const data ={
		url:url
	}

	const upload = await axios.post(`${process.env.REACT_APP_SERVER_URL}/delete-file`,data).catch(err=>{
		setMessage("Error while deleting")
		setOpen(true)
		setDeleting(false)
		console.log(err)
	})

	if (upload?.status == 200 && upload?.data?.success) {
		if (isLog) {
			setLogoUrl(null)
			setIsLogoUploaded(false)
			setFile(null)
		} else {
			setDocUrl(null)
			setIsDocUploaded(false)
			setFile(null)
		}
		setMessage(upload?.data?.message)
		setOpen(true)
		setDeleting(false)
		// setUploaded(false)
	} else {
		setMessage(upload?.data?.message)
		setOpen(true)
		setDeleting(false)
	}
	
} catch (error) {
	console.log(error)
	setDeleting(false)
}
}

	return(
	 <Grid container>
		<Grid item xs={12} sm={12} md={12} style={{height:40}}>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{width:"100%",justifyContent:"center",alignItems:"center"}}>
        <Box m={2} sx={{background:"#100101",minWidth:500,maxWidth:"70%",marginLeft:{sm:5,xs:5,md:17}}} display="flex" flexDirection="row" justifyContent="center" alignItems="flex-start">
            <Box mt={2} width="100%">
                <Header>
                    <Breadcrumbs aria-label="breadcrumb">
						<Typography color="text.primary" sx={{fontSize:12}}>Dashboard</Typography>
                        <Typography color="text.primary" sx={{fontSize:12}}>Job View</Typography>
                    </Breadcrumbs>			
                </Header>
                <Snackbar 
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }} 
                    message={message} 
                    onClose={()=>{setOpen(false)}}
                    open={open} 
                    autoHideDuration={2000}
                />
                <ContainerBox sx={{p:2,width:"90%"}}>
					<Box width="100%">
						<Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
							<Typography  mb={2} mt={2} ml={4} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
								Job View Application
							</Typography>	
							<IconButton onClick={(e)=>{
								e?.preventDefault()
								navigate("/jobs")
							}}>
								<ArrowBack fontSize='small' sx={{color:"gold"}}/>
							</IconButton>					
						</Box>
						<Box mb={2} ml={4}>
							<Typography color="gold" style={{fontFamily:"dinofans",marginBottom:5}}>
								Job Info
							</Typography>
							<Box display="flex" flexDirection="row" justifyContent="space-between" m={1} alignItems="center" width="80%">
								<Box>
									<Typography color="gray" style={{fontFamily:"dinofans"}}>
										Title
									</Typography>
									<Typography sx={{color:'white',marginBottom:1,fontSize:12}}>
										{data?.title} at {data?.enterprise_name}
									</Typography>
								</Box>
								<Box >
									<Typography color="gold" style={{fontFamily:"dinofans"}}>
										Deadline
									</Typography>
									<Typography color="gold" fontSize={14} width={80}>
										{data?.deadline}
									</Typography>
								</Box>
							</Box>
							<Box ml={1}>
								<Typography color="gray" style={{fontFamily:"dinofans"}}>
									Description
								</Typography>
								<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
									{data?.description}
								</Typography>
								<Box display="flex" flexDirection="row" width="60%">
									<Box m={1}>
										<Typography color="gray" style={{fontFamily:"dinofans"}}>
											Type
										</Typography>
										<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
											{data?.type}
										</Typography>
									</Box>
									<Box m={1}>
										<Typography color="gray" style={{fontFamily:"dinofans"}}>
											Location
										</Typography>
										<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
											{data?.location}
										</Typography>										
									</Box>
									<Box m={1}>
										<Typography color="gray" style={{fontFamily:"dinofans"}}>
											Category
										</Typography>
										<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
											{data?.category}
										</Typography>										
									</Box>
								</Box>
							</Box>
							<Box> 
							{
								hasStarted && (
									<Box mt={2} mb={2}>
										<Divider sx={{mb:2}}/>
										<Typography color="gray" style={{fontFamily:"dinofans"}}>
											Question
										</Typography>
										<Typography sx={{color:'white',fontSize:16,marginBottom:1,ml:2}}>
											{recentQuestion?.content}
										</Typography>
									</Box>
								)
							}
							{
								(recentQuestion?.type === "Simple" && hasStarted) && (
									<Box mt={2} mb={2} ml={2}>
                                        <MultiInput isRequired={recentQuestion?.isRequired} maxLength={recentQuestion?.maxLength} input={response} setInput={setResponse} label="answer"/>
                                    </Box>
								)
							}
							{
								(recentQuestion?.type === "One" && hasStarted) && (
									<Box justifyContent="center" alignItems="center" width="100%" m={1}>
										<FormControl>
											<RadioGroup
													aria-labelledby="demo-row-radio-buttons-group-label"
													name="row-radio-buttons-group"
												>
													{
														recentQuestion?.choices?.map((item,index)=>(
															<FormControlLabel key={index} value={item} control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
																setResponse(item)
															}} />} label={<Typography  sx={{fontSize:12}}>{item}</Typography>} />
														))
													}
												</RadioGroup>                        
										</FormControl>
                                    </Box> 
								)
							}
							{
								(recentQuestion?.type === "Multiple" && hasStarted) && (
									<Box justifyContent="center" alignItems="center" width="100%" mt={2}>
										<FormControl>
											<FormLabel sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}} id="demo-row-radio-buttons-group-label">Choose :</FormLabel>
												{
													recentQuestion?.choices?.map((item,index)=>(
														<FormControlLabel key={index} control={<Checkbox checked={responses.includes(item)} sx={{fontSize:11,color:"#ff0",ml:2}} value={item} onClick={(e)=>{
															e.preventDefault()
															setResponses((prevResponses) => {
																if (prevResponses.includes(item)) {
																	return prevResponses.filter((response) => response !== item);
																} else {
																	return [...prevResponses, item];
																}
															})
														}} />} label={<Typography  sx={{fontSize:12}}>{item}</Typography>} />
													))
												}                   
										</FormControl>
                                    </Box> 
								)
							}
							{
								(recentQuestion?.type === "Image" && hasStarted) && (
									<Box m={1} mb={2}>
										<Box pl={2} mt={2} mb={1} justifyContent="center" alignItems="center" width="40%">
											<FileUploader onDrop={(file)=>{setFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
												setFile(file)
											}} name="file" types={fileTypes} />
										</Box>
										{file !== null && (
											<Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
												<Button disabled={uploading || isLogoUploaded} onClick={(e)=>{
													e.preventDefault()
													handleUploadFile(file,true)
												}}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
													Upload
												</Button>
												{
													isLogoUploaded && (
														<Button disabled={deleting} onClick={(e)=>{
															e.preventDefault()
															handleDeleteFile(logoUrl,false)
														}}  sx={{background:"maroon",color:"#fff",fontFamily:"dinofans",fontSize:10}} variant="contained">
															Delete
														</Button>
													)
												}
											</Box>
										)}
									</Box>
								)
							}
							{
								(recentQuestion?.type === "Files" && hasStarted) && (
									<Box m={1}>
										<Box pl={2} mt={2} justifyContent="center" alignItems="center" width="40%">
											<FileUploader onDrop={(file)=>{setFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
												setFile(file)
											}} name="file" types={docTypes} />
										</Box>
										{file !== null && (
											<Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
												<Button disabled={uploading || isDocUploaded} onClick={(e)=>{
													e?.preventDefault()
													handleUploadFile(file,false)
												}}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
													Upload
												</Button>
												{
													isDocUploaded && (
														<Button disabled={deleting} onClick={(e)=>{
															e?.preventDefault()
															handleDeleteFile(docUrl,false)
														}}  sx={{background:"maroon",color:"#fff",fontFamily:"dinofans",fontSize:10}} variant="contained">
															Delete
														</Button>
													)
												}
											</Box>
										)}
									</Box>
								)
							}
							{
								(recentQuestion?.type === "Link" && hasStarted) && (
									<Box mt={2} mb={2}>
                                        <UserInput input={response} setInput={setResponse} label="link">
											<LinkRounded/>
										</UserInput>
                                    </Box>
								)
							}
							{
								!hasStarted && (
									<Box mt={2} mb={2}>
                                        {
											hasEnded ?
											<Box mt={2} mb={2}>
												<Typography  m={1} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
													Congratulation !
												</Typography>
												<Typography sx={{color:'white',fontSize:12,marginBottom:1,ml:2}}>
													You have successfully submitted your application !
												</Typography>
											</Box>
											:
											<Box>
												{
													!isMatched && (
														<Box  justifyContent="flex-start" alignItems="center"  sx={{background:"#000",padding:1,borderRadius:2}}>
															<Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="40%">
																<Box sx={{margin:1,padding:2,color:"gray",textAlign:"left",marginBottom:0,justifyContent:"flex-start"}}>
																	<Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:13}}>
																		CV or Resume
																	</Typography>
																	{
																		user?.cv !== "" ?
																			<Button  onClick={(e)=>{
																				e?.preventDefault()
																				setViewDoc(true)
																			}}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
																				View
																			</Button>
																		:
																			<Typography color="white" ml={1} fontSize={14} sx={{whiteSpace:"pre-wrap"}}>
																				Not found
																			</Typography>
																	}
																</Box>
																<IconButton onClick={(e)=>{
																	setEdited("cv")
																	setShowEdited((prev)=>!prev)
																}}>
																	<Edit fontSize='small'/>
																</IconButton>
															</Box>
															{
																(showEdited && edited === "cv") && (
																<Box m={3}>
																	<Typography sx={{fontSize:12,color:"#fff",m:2}}>upload cv</Typography>
																	<Box pl={2} mt={2} justifyContent="center" alignItems="center" width="40%">
																		<FileUploader  onDrop={(file)=>{setFileCv(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
																			setFileCv(file)
																		}} name="files" types={["PDF"]} />
																	</Box>
																	{
																		fileCv !== null && (
																			<Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
																				<Button disabled={uploading} onClick={async (e)=>{
																					e?.preventDefault()
																					await handleUpdateCv()
																				}}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
																					Update
																				</Button>
																			</Box>
																		)
																	}
																</Box>
																)
															}
															<Box ml={3} mb={2}>
																<UserInput input={email} setInput={setEmail} label="Confirm your email">
																	<EmailOutlined/>
																</UserInput>
															</Box>
															<Button onClick={async (e)=>{
																	e?.preventDefault()
																	await handleMatch()
															}} disabled={matching || user?.cv === ""} sx={{backgroundColor:"gold",color:"black",marginLeft:3,fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
																{
																	matching ?  <CircularProgress size={20} sx={{color:"black"}}/>  : "Match"
																}
															</Button>         
														</Box>
													)
												}
											</Box>
										}
										<CardViewDialog  visible={viewDoc} setVisible={setViewDoc} data={user?.cv} title="your CV or Resume"/>
									</Box>
								)
							}
							{
								hasEnded ?
									<Button onClick={async (e)=>{
											e?.preventDefault()
											navigate("/jobs")
										}} disabled={submitting ? true : false} sx={{backgroundColor:"gold",color:"black",marginLeft:1,marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
										Close
									</Button>
								:
									<>
										{
											isMatched && (
												<Button onClick={async (e)=>{
														e?.preventDefault()
														await handleSend()
													}} disabled={submitting ? true : false} sx={{backgroundColor:"gold",color:"black",marginLeft:1,marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
													{
														submitting ?  <CircularProgress size={20} sx={{color:"black"}}/>  :  (!submitting && hasStarted) ? "Next" : "Start"
													}
												</Button>
											)
										}
									</>
							}
						</Box>
						</Box>
						<AnalyzeDialog data={analyzeData} visible={showModal} setVisible={setShowModal}/>
					</Box>
                </ContainerBox>
            </Box>
        </Box>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{height:40}}>
		</Grid>
	 </Grid>
	)}

	export default JobApplication